document.addEventListener("DOMContentLoaded", function () {
    // Hämta alla single-lunch-element inom .lunches
    const lunches = document.querySelector(".lunches");
    const lunchItems = lunches ? lunches.querySelectorAll(".single-lunch") : [];

    // Kontrollera att det finns lunchposter
    if (lunchItems.length > 0) {
        // Gör den första posten aktiv och byt ikon vid sidladdning
        const firstLunch = lunchItems[0];
        firstLunch.classList.add("active");
        const firstIcon = firstLunch.querySelector("i");
        if (firstIcon) {
            firstIcon.classList.remove("icon-add");
            firstIcon.classList.add("icon-remove");
        }

        // Lägg till klickhändelser på varje .single-lunch
        lunchItems.forEach((item) => {
            item.addEventListener("click", function () {
                const isActive = item.classList.contains("active");

                // Ta bort .active och återställ ikoner för alla lunchposter
                lunchItems.forEach((i) => {
                    i.classList.remove("active");
                    const icon = i.querySelector("i");
                    if (icon) {
                        icon.classList.remove("icon-remove");
                        icon.classList.add("icon-add");
                    }
                });

                // Om posten inte redan var aktiv, gör den aktiv och byt ikon
                if (!isActive) {
                    item.classList.add("active");
                    const icon = item.querySelector("i");
                    if (icon) {
                        icon.classList.remove("icon-add");
                        icon.classList.add("icon-remove");
                    }
                }
            });
        });
    }
});
//# sourceMappingURL=lunch.js.map
